<template>
    <div>
        <v-card>
            <v-row class="ml-1 mr-1">
                <v-col cols="11">
                    <v-card-title class="titulopagina">MERMAS DE ACEITE</v-card-title>
                </v-col>
                <v-col cols="1">
                    <v-alert class="amber accent-2 text-center" color="orange" outlined dense @click="abrirAyudas"><v-icon color="blue" large>help</v-icon></v-alert>
                </v-col>
            </v-row>
		    <modal-ayuda></modal-ayuda>
        </v-card>
        <v-row class="ml-1 mr-1">
            <v-col cols="12">
                <v-row class="ml-1 mr-1" v-if="alert">
                    <v-alert dense text type="success">
                        Merma Guardada Correctamente <strong>!</strong> <v-btn icon class="float-right" color="green darken-3" @click="alert=!alert"><v-icon>cancel</v-icon></v-btn>
                    </v-alert>
                </v-row>
            </v-col>
        </v-row>
        <v-row class="ml-1 mr-1">
            <v-col cols="3">
                <v-card>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Fecha Prod:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <date-picker 
                                v-model="despacho.fecha" 
                                placeholder ="Seleccione Fecha" 
                                format="DD-MM-YYYY" 
                                :default-value="despacho.fecha" 
                                valueType="YYYY-MM-DD"
                                @change="cargarDespacho(); cargarEstanques(); cargarStocks();"
                            ></date-picker>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Fecha Desp:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <date-picker 
                                v-model="despacho.fecha_despacho" 
                                placeholder ="Fecha Salida Merma" 
                                format="DD-MM-YYYY" 
                                :default-value="despacho.fecha_despacho" 
                                valueType="YYYY-MM-DD"
                            ></date-picker>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Guia:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <v-text-field v-model="despacho.guia" label="N° Guia" placeholder="N° Guia"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Folio:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <v-text-field v-model="despacho.folio_destino" label="Folio Destino" placeholder="Folio Destino"></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            TK:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <v-select
                                :items="estanques"
                                item-text="codigo"
                                item-value="id"
                                v-model="despacho.estanque_aceites_id"
                                label="Estanque"
                                @change="cargarStocks"
                                dense>
                            </v-select>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="col-md-3 col-sm-6">
                            Litros:
                        </v-col>
                        <v-col class="col-md-9 col-sm-6">
                            <label label="Cantidad" >{{distribuir}}</label>
                        </v-col>
                    </v-row>
                    <v-row class="ml-1 mr-1">
                        <v-col class="text-center">
                            <v-btn :disabled="distribuir == 0 || bloquear || despacho.guia == '' || despacho.fecha == ''" class="green darken-1" @click="generarDespacho">Grabar</v-btn>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-alert dense text type="info">
                            La opción de grabar se habilita cuando hay fecha, guía y suma de Litros es mayor a 0. Y la opción de "limpieza de estanque" se habilita cuando el stock es igual a lo que se está mermando (cuando el estanque quedará en stock cero)
                        </v-alert>
                    </v-row>
                </v-card>
            </v-col>
            <v-col cols="9">
                <v-card elevation="15">
                    <v-card-text>
                        <v-row>
                            <span class="pl-5 pr-5"> Stock {{tk}} : {{stock | formatear_miles}} </span>
                            <span class="pl-5 pr-5" v-if="(diferencia == 0) && despacho.estanque_aceites_id"> 
                                <v-checkbox
                                    v-model="despacho.limpieza_tk"
                                    label="Registrar como limpieza de Estanque"
                                    class="pt-0 mb-6"
                                    color="blue"
                                    hide-details
                                ></v-checkbox>
                            </span>
                        </v-row>
                        <v-row v-if="alerta_graba" >
                            <v-alert dense text type="warning">
                                No se puede mermar más que lo disponible en cada fila
                            </v-alert>
                        </v-row>
                        <v-row>
                            <table width="100%">
                                <thead>
                                    <tr>
                                        <th class="cabecera borde-left">Estanque</th>
                                        <th class="cabecera borde-left">Fecha Prod.</th>
                                        <th class="cabecera borde-left">Linea</th>
                                        <th class="cabecera borde-left">Materia Prima</th>
                                        <th class="cabecera borde-left">Producción</th>
                                        <th class="cabecera borde-left">Despachado</th>
                                        <th class="cabecera borde-left">Disponible</th>
                                        <th class="cabecera borde-left">Mermar</th>
                                    </tr>
                                </thead>

                                <tr v-for="item in estanques_producciones" :key="item.id">
                                    <td> {{item.estanque}} </td>
                                    <td> {{item.fecha}} </td>
                                    <td class="text-center"> {{item.lineas_id}} </td>
                                    <td> {{item.tipo_materia_prima}} </td>
                                    <td class="text-right"> {{ item.produccion | formatear_miles }} </td>
                                    <td class="text-right"> {{ item.despachado || 0 | formatear_miles }} </td>
                                    <td class="text-right"> {{ parseInt(item.disponible || 0) | formatear_miles }} </td>
                                    <td class="text-right">
                                        <v-text-field hide-details="auto" class="ml-2 pt-0 text-right" v-model="item.merma" @change="validaPropuesta(item,$event)"> </v-text-field>
                                    </td>
                                </tr>
                            </table>
                        </v-row>
                    </v-card-text>
                </v-card>
                <hr class="mt-4">
                <v-col cols="12" class="mt-6">
                    <label>Búsqueda de Despachos por fecha:</label>
                    <date-picker class="float-right" v-model="fechas" @change="cargarDespachos"
                        range-separator="|" range placeholder ="Búsqueda por Fechas" 
                        format="DD-MM-YYYY" :default-value="fechas" valueType="YYYY-MM-DD">
                    </date-picker>
                    <confirm-dialogue ref="confirmDialogue"></confirm-dialogue>
                </v-col>

                <v-col cols="12" class="mt-4">
                    <v-data-table :headers="encabezado" :items="despachos" class="elevation-1">
                        <template v-slot:item.actions="{ item }">
                            <v-icon small class="mr-6" @click="editDespacho(item)">edit</v-icon>
                            <v-btn color="red darken-4" dark small icon @click="eliminar(item)">
                                <v-icon>delete</v-icon>
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-col>
            </v-col>
        </v-row>
    </div>
</template>
<script>
import { mapState,mapMutations } from 'vuex'
//datepicker vue2
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/es';
import ConfirmDialogue from '@/components/ConfirmDialogue.vue'
import ModalAyudas from '@/components/shared/ModalAyudas.vue';

export default {
    data:()=>({
        id: 0,
        alert: false,
        alerta_graba: false,
        bloquear: false,
        despachos: [],
        estanques: [],
        estanques_producciones: [],
        fechas:null,
        solo_mermas:false,
        stock:1,
        distribuir:0,
        tk:'',
        despacho: {
            fecha: '',
            fecha_despacho: '',
            guia: '',
            folio_destino: '',
            estanque_aceites_id: 0,
            cantidad: '',
            limpieza_tk: false,
            mermas:[],
        },
        encabezado: [
            { text: 'Fecha', value: 'fecha', class:"cabecera" },
            { text: 'Guia', value: 'guia', class:"cabecera" },
            { text: 'Patente', value: 'patente', class:"cabecera" },
            { text: 'Folio Dest', value: 'folio_destino', class:"cabecera" },
            { text: 'Estanque', value: 'codigo', class:"cabecera" },
            { text: 'Cantidad', value: 'cantidad', class:"cabecera" },
            { text: 'Opciones', value: 'actions', sortable: false, class:"cabecera"},
        ],
    }),
    mounted(){
        this.despacho.fecha = this.moment().format('YYYY-MM-DD');
        this.fechas = this.moment().format('YYYY-MM-DD');
        this.cargarDespacho();
        this.cargarEstanques();
        this.cargarStocks();
    },
    methods:{
        editDespacho(item){
            this.despacho.fecha = item.fecha
            this.despacho.fecha_despacho = item.fecha
            this.despacho.guia = item.guia
            this.despacho.folio_destino = item.folio_destino
            this.despacho.estanque_aceites_id = item.estanque_aceites_id
            this.despacho.cantidad = item.cantidad
        },
        abrirAyudas(){
            let jiji = [
                        {   titulo:`Ayuda de Registro de Mermas de Aceite `,    tipo:`titulo`},
                        {   tipo:`label`,   texto:`En esta pantalla se registran las mermas de aceite de los estanques de planta asociadas a una producción de origen: Fecha del despacho, Número de Guía, Folio de Destino, Estanque de origen y la cantidad.`},
                        {   tipo:`label`,   texto:`- En la tabla del lado derecho se pueden realizar búsquedas por fecha o se puede modificar un registro.`},
                    ]
            
            Event.$emit('mostrar_alert',jiji);
        },
        async cargarEstanques(){
            if (!this.despacho.fecha) {
                this.despacho.fecha = this.moment().format('YYYY-MM-DD')
            }
            console.log("cargar tk 2 ", this.despacho.fecha)
            let url = `${this.base_url}estanques/stock/${this.despacho.fecha}`;
            await this.axios.get(url,this.headers).then((response)=>{
                this.estanques = response.data.data;
            }).catch((error)=>{
                this.errorMessage(error, "Error al cargar estanques ");
            });
            let idx = this.estanques.findIndex(r => r.id == this.despacho.estanque_aceites_id)
            this.stock = this.estanques[idx] ? this.estanques[idx].stock : 1
            this.tk = this.estanques[idx] ? this.estanques[idx].codigo : ''
            console.log(this.stock)
        },
        async cargarDespacho(){
            this.mostrarLoading({titulo:`Buscando Despachos  ${this.despacho.fecha} ...`, color:'green'});
            if (!this.despacho.estanque_aceites_id)  this.despacho.estanque_aceites_id = 0
            let body = {
                estanque: this.despacho.estanque_aceites_id,
                fecha_ini: this.despacho.fecha,
                solo_mermas: this.solo_mermas,
            }

            let url = `${this.base_url}listado_despachos`;
            await this.axios.post(url, body, this.headers).then((res)=>{
                this.despachos = res.data.data;
                this.ocultarLoading();
            }).catch((e)=>{
                this.errorMessage(e,"Error al cargar despachos ");
            });
            
        },
        async cargarDespachos(){
            this.mostrarLoading({titulo:`Buscando Despachos entre ${this.fechas[0]} y ${this.fechas[1]} ...`, color:'green'});
            if (!this.despacho.estanque_aceites_id)  this.despacho.estanque_aceites_id = 0
            let body = {
                estanque: this.despacho.estanque_aceites_id,
                fecha_ini: this.fechas[0],
                fecha_fin: this.fechas[1],
                solo_mermas: this.solo_mermas,
            }

            let url = `${this.base_url}listado_despachos`;
            await this.axios.post(url, body, this.headers).then((res)=>{
                this.despachos = res.data.data;
                this.ocultarLoading();
            }).catch((e)=>{
                this.errorMessage(e, "Error al cargar despachos ");
            });
        },

        async generarDespacho(){
            this.bloquear = true;
            this.mostrarLoading({titulo:'Generando Despacho...',color:'green'})
            
            let toSave = []
            let data = {}
            let cantidad = 0
            this.estanques_producciones.forEach( row => {
                if (row.merma > 0) {
                    data = { "pt_id":row.id, "merma":row.merma, "estanque":row.estanque_aceites_id};
                    toSave.push( data );
                    cantidad += parseInt(row.merma || 0);
                }
            });
            this.despacho.cantidad = cantidad;
            this.despacho.mermas = toSave;
            //this.despacho.mermas.push( toSave );

            if (data != {}) {
                 let url = `${this.base_url}despachos_pts/registrar_merma`;
                await this.axios.post(url, this.despacho, this.headers).then((res)=>{
                    console.log('despacho creado', res.data.data);
                    this.alert = true;
                    this.ocultarLoading();
                    this.cargarDespacho();
                    this.cargarEstanques();
                    this.cargarStocks();
                    this.despacho.guia = '';
                }).catch((e)=>{
                    this.errorMessage(e, "Error al grabar registro de merma ");
                });
            } else {
                this.errorMessage("Error", "no se han encontrado mermas (valores mayor a cero en columna Mermar)");
            }
            this.bloquear = false;
            
        },
        async eliminar(item){
            const okei = await this.$refs.confirmDialogue.show({
                title: 'Confirmar eliminación',
                message: 'Desea eliminar despacho de aceite ?',
                okButton: 'Eliminar !!',
            })
            if(okei) {
                let body = { _method:"DELETE"}
                await this.axios.post(`${this.base_url}despacho_aceites/${item.id}`,body,this.headers).then((res)=>{
                    this.despacho = {fecha: this.moment().format('YYYY-MM-DD')}
                    this.cargarDespacho();
                }).catch((e)=>{
                    this.errorMessage(e, "Error al grabar despacho ");
                });
            }
        },
        revisar_comas(){
            this.despacho.acidez = Number(this.despacho.acidez.replace(/,/g, '.'));
        },
        async cargarStocks(){
            if (this.despacho.estanque_aceites_id && this.despacho.fecha) {
                let url = `${this.base_url}stock_de_estanque/${this.despacho.estanque_aceites_id}/${this.despacho.fecha}`;
                await this.axios.get(url,this.headers).then(async (res)=>{
                    this.estanques_producciones = res.data.data;
                }).catch((error)=>{
                    console.log('error',error);
                });
                let idx = this.estanques.findIndex(r => r.id == this.despacho.estanque_aceites_id)
                this.stock = this.estanques[idx] ? this.estanques[idx].stock : 1
                this.tk = this.estanques[idx] ? this.estanques[idx].codigo : ''
                console.log(this.stock)
            }
            
        },
        validaPropuesta(item, event) {
            let idx = this.estanques_producciones.findIndex(r => r.id == item.id)
            let disponible = parseInt(item.disponible || 0)
            let merma = parseInt(item.merma || 0)
            console.log('disponible',disponible,'merma',merma,'event',event,'idx',idx,'item',item);
            if (merma > disponible) {
                // AQUI SE MANTIENE EL VALOR QUE EL USUARIO DIGITÓ EN INPUT
                this.alerta_graba = true
                this.$set(this.estanques_producciones[idx], 'merma', 0);
                this.$set(this.estanques_producciones[idx], "color", 5)
            } else {
                // AQUI SE DEBE VOLVER AL VALOR QUE EL INPUT TENIA ANTES DEL CHANGE
                this.alerta_graba = false
                this.$set(this.estanques_producciones[idx], 'merma', event);
                this.$set(this.estanques_producciones[idx], 'color', 3)
            }
        },
        ...mapMutations(['mostrarLoading', 'ocultarLoading'])
    },
    computed:{
        diferencia(){
            this.distribuir = 0;
            this.estanques_producciones.forEach(e => {
                this.distribuir += parseInt(e.merma || 0);
            });
            let calculo = this.stock - this.distribuir
            if (calculo != 0) {
                this.despacho.limpieza_tk  = false
            }
            return (calculo);
        },
        ...mapState(['base_url', 'headers'])
    },
    components:{
        DatePicker,
        ConfirmDialogue,
        'modal-ayuda':ModalAyudas
    },

}
</script>
<style scoped>
    .v-input--selection-controls {
        margin-top: 0px;
        padding-top: 0px;
    }
    .v-text-field {
        padding-top: 4px !important;
    }
</style>